import Headerabout from '../../components/Headerabout'
import HeaderImage from '../../images/header_bg_5.jpg'
import {MdEmail} from 'react-icons/md'
import {BsMessenger} from 'react-icons/bs'
import {IoLogoWhatsapp} from 'react-icons/io'








import './contact.css'

const Contact = () => {
  return (
    <>
      <Headerabout title = "Get In toutch" image = {HeaderImage}>

      It was also to protect the channel should the competition,
      the satellite or cable competition hit their adverts.

      </Headerabout>
      <section className='contact'>

        <div className="container container_co">

          <div className="contact_wrapper">
            <a href="mailto:omarkhderrr@gmail.com" target='__blank' rel='noreferrer noopener'><MdEmail/></a>
            <a href="http://m.me/ernest_achiever" target='__blank' rel='noreferrer noopener'><BsMessenger/></a>
            <a href="http://wa.me/0201010741386" target='__blank' rel='noreferrer noopener'><IoLogoWhatsapp/></a>

          
          </div>


        </div>
      </section>
      
    </>
  )
}

export default Contact
